import { useSkin } from '@hooks/useSkin'
import { Link } from 'react-router-dom'
import { Row, Col, CardTitle, CardText } from 'reactstrap'
import '@styles/base/pages/page-auth.scss'

// import vitaLogo from "assets/images/logo/logo-vita.png"

const AuthWrapper = (props) => {
  const [skin] = useSkin()

  const illustration = skin === 'dark' ? 'login-v2-dark.svg' : 'login-v2.svg',
    source = require(`@src/assets/images/pages/${illustration}`).default

  return (
    <div className='auth-wrapper auth-v2'>
      <Row className='auth-inner m-0'>
        <Link className='brand-logo' to='/'>
          {/* <img className="vita-wizard-brand" src={vitaLogo} alt="logo" /> */}
          <h2 className='brand-text text-primary ml-1'>Vita Verify</h2>
        </Link>
        <Col className='d-none d-lg-flex align-items-center' lg='5' md='12' sm='12'>
          <div className='w-100 d-lg-flex align-items-center justify-content-center'>
            <img className='img-fluid' src={source} alt='Login V2' />
          </div>
        </Col>
        <Col className='d-flex align-items-center auth-bg px-2 p-lg-5' lg='7' md='12' sm='12'>
          <Col className='px-xl-2 mx-auto' sm='8' md='6' lg='12'>
            <CardTitle tag='h2' className='font-weight-bold mb-1'>
              Welcome!
            </CardTitle>
            <CardText className='mb-2'>Let's start the adventure</CardText>
            {props.children}
            {/* <p className='text-center mt-2'>
              <span className='mr-25'>New on our platform?</span>
              <Link to='/'>
                <span>Create an account</span>
              </Link>
            </p> */}
            {/* <div className='divider my-2'>
              <div className='divider-text'>or</div>
            </div> */}
            {/* <div className='auth-footer-btn d-flex justify-content-center'>
              <Button.Ripple color='facebook'>
                <Facebook size={14} />
              </Button.Ripple>
              <Button.Ripple color='twitter'>
                <Twitter size={14} />
              </Button.Ripple>
              <Button.Ripple color='google'>
                <Mail size={14} />
              </Button.Ripple>
              <Button.Ripple className='mr-0' color='github'>
                <GitHub size={14} />
              </Button.Ripple>
            </div> */}
          </Col>
        </Col>
      </Row>
    </div>
  )
}

export default AuthWrapper
